export default __webpack_public_path__ + "static/media/1815.99042f46.png";